export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Скачать JPG файл',
    downloadPDF: 'Скачать PDF файл',
    downloadPNG: 'Скачать PNG файл',
    downloadSVG: 'Скачать SVG файл',
    exportButtonTitle: 'Экспортировать',
    forexRate: 'Курс валют FOREX',
    loading: 'Загрузка...',
    months: [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь',
    ],
    printButtonTitle: 'Печатать',
    rangeSelectorFrom: 'С',
    rangeSelectorTo: 'До',
    rangeSelectorZoom: 'Приблизить',
    rateTypes: {
      ask: 'Лучшее предложение по продаже',
      bid: 'Лучшее предложение по покупке',
      forex: 'Средний курс в мире',
    },
    resetZoom: 'Восстановить',
    resetZoomTitle: 'Восстановить',
    shortMonths: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    thousandsSep: ' ',
    weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    wtBestAsk: 'Лучшее предложение по продаже',
    wtBestBid: 'Лучшее предложение по покупке',
  },
  calculator: {
    title: 'Рассчитайте экономию в Walutomat',
    forBuy: 'для',
    unsupportedPair: 'В настоящее время мы не предлагаем курсы для выбранной валютной пары.',
    spinnerError: {
      generic: 'Возникла проблема с загрузкой данных',
      toManyRequests:
        'В настоящее время калькулятором пользуется очень много пользователей. Повтори попытку позже или обратись в Оттдел Обслуживания Клиента <a href="https://www.walutomat.com/ru/kontakt/">https://www.walutomat.com/ru/kontakt/</a>.',
    },
    commissionWT: 'Комиссия Walutomat',
    continueButton: 'Продолжить обмен',
    amountText: 'Сумма',
  },
  continueButton: {
    createAccount: 'Создать бесплатный аккаунт',
    logIn: 'Войти',
    check: 'Проверить',
    checkWhyWorth: 'почему это стоит того',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title: 'Проверь курсы и{{nbsp}}обменяй валюту в{{nbsp}}Walutomat – быстро и{{nbsp}}выгодно.',
    actualRate: 'Текущий обменный курс',
    buySelect: 'Покупаю',
    sellSelect: 'Продаю',
    buttonText: 'Обменять',
    exchangeAmountSellLabel: 'Вы получите',
    exchangeAmountBuyLabel: 'Внесите',
    commission: 'Промо-комиссия ({{commission}}%)',
  },
  formValidation: {
    emptyField: 'Поле, обязательное для заполнения',
    requiredField: 'Поле, обязательное для заполнения',
    requireAllFields: 'Все поля должны быть заполнены',
    passwordToShort: 'Поле должно состоять из 8 символов',
    emailNotValid: 'Aдрес email неправильный',
    emailReserved: 'Данный email уже существует',
    emailUnregistered: 'Не найдено адреса электронной почты в нашей базе клиентов.',
    markField: 'Отметьте хотя бы один из флажков',
    serverUnknownError: 'Ошибка связи с сервером',
    invalidCharacters: 'Поле содержит недопустимые символы',
    phoneNotValid: 'Номер телефона неверен',
    checkBoxBelow: 'Пожалуйста, отметьте поле ниже, чтобы отправить сообщение',
    promocodeInvalid: 'Неправильный код рекламной акции',
    newsletterAlreadySubscribed: 'Этот адрес электронной почты уже подписан на рассылку новостей.',
  },
  password: {
    show: 'Показать',
    hide: 'скрывать',
  },
  howItWorks: {
    showButton: 'Показать больше',
    hideButton: 'Показать меньше',
  },
}
